(() => {
  const STYLE_ID = 'kruzer-filter-scroll-safe';
  const SAFE_CSS = `
    .kmc .kmc-filters,
    .kmc .kmc-filters.is-stuck,
    .kmc .kmc-filters.is-expanded {
      position: relative !important;
      inset: auto !important;
      top: auto !important;
      bottom: auto !important;
      z-index: 20 !important;
      max-height: none !important;
      height: auto !important;
      overflow: visible !important;
      overflow-x: visible !important;
      overflow-y: visible !important;
      overscroll-behavior: auto !important;
      touch-action: auto !important;
      contain: none !important;
      transform: none !important;
    }
    .kmc .kmc-filter-body,
    .kmc .kmc-filter-drawer,
    .kmc .kmc-filter-content {
      max-height: none !important;
      overflow: visible !important;
      overscroll-behavior: auto !important;
      touch-action: auto !important;
    }
    .kmc .kmc-filter-compact-toggle { display: inline-flex !important; }
    .kmc .kmc-filter-toggle { display: none !important; }
    .kmc .kmc-filter-group { display: none !important; }
    .kmc .kmc-filters.is-expanded .kmc-filter-group { display: grid !important; }
    html.kmc-filter-open, body.kmc-filter-open,
    html.kmc-filters-open, body.kmc-filters-open {
      position: static !important;
      height: auto !important;
      overflow: auto !important;
      touch-action: auto !important;
    }
  `;

  const placeFinalStyle = () => {
    document.getElementById(STYLE_ID)?.remove();
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = SAFE_CSS;
    document.head.appendChild(style);
  };

  const unlockPage = (scope = document) => {
    placeFinalStyle();

    document.documentElement.classList.remove('kmc-filter-open', 'kmc-filters-open');
    document.body.classList.remove('kmc-filter-open', 'kmc-filters-open');

    scope.querySelectorAll?.('[data-kmc] .kmc-filters').forEach((filters) => {
      filters.classList.remove('is-stuck');
      filters.style.removeProperty('position');
      filters.style.removeProperty('top');
      filters.style.removeProperty('bottom');
      filters.style.removeProperty('height');
      filters.style.removeProperty('max-height');
      filters.style.removeProperty('overflow');
      filters.style.removeProperty('overflow-y');
      filters.style.removeProperty('transform');

      const toggle = filters.querySelector('.kmc-filter-compact-toggle');
      if (toggle) {
        toggle.setAttribute('aria-expanded', filters.classList.contains('is-expanded') ? 'true' : 'false');
      }
    });
  };

  const blockInitialFilterJump = () => {
    const original = Element.prototype.scrollIntoView;
    let active = true;

    Element.prototype.scrollIntoView = function (...args) {
      if (active && this instanceof Element && this.id === 'modele' && this.closest('[data-kmc]')) {
        return;
      }
      return original.apply(this, args);
    };

    window.setTimeout(() => {
      active = false;
      Element.prototype.scrollIntoView = original;
    }, 700);
  };

  const boot = (scope = document) => {
    blockInitialFilterJump();
    window.setTimeout(() => unlockPage(scope), 0);
    window.setTimeout(() => unlockPage(scope), 120);
    window.setTimeout(() => unlockPage(scope), 500);

    if (window.location.hash === '#modele') {
      history.replaceState({}, '', `${window.location.pathname}${window.location.search}`);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  } else {
    boot(document);
  }

  window.addEventListener('scroll', () => {
    document.querySelectorAll('[data-kmc] .kmc-filters.is-stuck').forEach((filters) => filters.classList.remove('is-stuck'));
  }, { passive: true });

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
